<template>
  <div class="evaluation_big_box">
    <img
      class="evaluation_icon"
      :src="require('@/assets/images/books/book2/evaluation_icon.png')"
      alt=""
    />
    <div class="title">My Self-Assessment Report</div>
  </div>
</template>
   
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
   
<style scoped lang='scss'>
.evaluation_big_box {
  position: relative;
  .evaluation_icon {
    position: absolute;
    top: -110rem;
    left: 50%;
    transform: translateX(-50%);
    width: 100rem;
    height: 80rem;
  }
  .title{
    width:380rem;
    height:60rem;
    line-height: 60rem;
    text-align: center;
    color:#fff;
    font-size: 26rem;
    border-radius: 10rem;
    background: #5CA683;
    position: absolute;
    left:50%;
    top:-30rem;
    transform: translateX(-50%);
  }
}
</style>